import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useContactPersonReadQuery } from 'api';

export const useContactPerson = () => {
  const [addModalState, setAddModalState] = useState<boolean>(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState<boolean>(false);
  const [contactPersonId, setContactPersonId] = useState<string | null>(null);
  const { id } = useParams() as { id: string };
  const { data = [] } = useContactPersonReadQuery({ entityId: id });
  const onAddModalOpen = useCallback(() => {
    setAddModalState(true);
  }, []);

  const onAddModalClose = useCallback(() => {
    setAddModalState(false);
    setContactPersonId(null);
  }, []);
  const onDeleteModalOpen = useCallback((id: string) => {
    setContactPersonId(id);
    setIsDeleteOpen(true);
  }, []);

  const onDeleteModalClose = useCallback(() => {
    setIsDeleteOpen(false);
  }, []);

  const onUpdateModalOpen = useCallback((id: string) => {
    setAddModalState(true);
    setContactPersonId(id);
  }, []);

  const personDetails = useMemo(() => {
    return data.find((_record: Record<string, any>) => _record.id === contactPersonId);
  }, [data, contactPersonId]);
  return {
    addModalState,
    isDeleteOpen,
    personDetails,
    data,
    onAddModalClose,
    onAddModalOpen,
    onDeleteModalClose,
    onDeleteModalOpen,
    onUpdateModalOpen,
  };
};
